export const onGetCurrentPage = (skip: number, top: number) => {
    if (skip === 0) {
        return skip + 1
    }
    return skip / top + 1
}
